export const MODES = {
  EMAIL: "email",
  SMS: "sms"
};

export const DEFAULT_PAGE_SIZE = 1;
